/**
 * A repair ticket's lifecycle, from booking to hand-back. Shaped like the
 * order and stock-request machines for the same reason: one pattern for
 * "what can this record legally become next" everywhere it appears.
 *
 * `awaiting_dropoff` is a ticket that exists only on paper — booked at
 * checkout, device not yet in the shop. `intake` is where it has always
 * meant "device received / checked in"; a ticket only reaches it once a
 * technician has the device in hand.
 */
export const REPAIR_STATUSES = [
    'awaiting_dropoff',
    'intake',
    'diagnosing',
    'awaiting_parts',
    'in_repair',
    'ready_for_pickup',
    'completed',
    'cancelled',
];
/** Truly final — nothing follows either of these. */
export const TERMINAL_REPAIR_STATUSES = ['completed', 'cancelled'];
/**
 * No work has begun yet — safe for an order cancellation to sweep away
 * automatically. `awaiting_dropoff` means the device is not even in the shop
 * yet; `intake` means it arrived but nothing has been done to it. Anything
 * past this point means a technician may already have opened the device, so
 * it needs a person to decide, not an automatic cancel.
 */
export const EARLY_REPAIR_STATUSES = ['awaiting_dropoff', 'intake'];
export const REPAIR_TRANSITIONS = {
    awaiting_dropoff: ['intake', 'cancelled'],
    intake: ['diagnosing', 'in_repair', 'cancelled'],
    diagnosing: ['awaiting_parts', 'in_repair', 'ready_for_pickup', 'cancelled'],
    awaiting_parts: ['in_repair', 'diagnosing', 'cancelled'],
    in_repair: ['awaiting_parts', 'ready_for_pickup', 'cancelled'],
    ready_for_pickup: ['completed', 'in_repair', 'cancelled'],
    completed: [],
    cancelled: [],
};
export function canTransitionRepair(from, to) {
    return REPAIR_TRANSITIONS[from].includes(to);
}
//# sourceMappingURL=repair-states.js.map